export default "__VITE_ASSET__DCE3SW3P__"